module.exports = __webpack_public_path__ + "static/media/emma_vp_chihachevo.1d1d8529.jpg";